import type { KeyValueStore } from '../core';

/** Browser save for the last loadout of each hero. A blocked store still lets the duel start. */
export const browserStore: KeyValueStore = {
  getItem(key) {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  setItem(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch {
      // Private mode can refuse the write. The in-memory pick still starts the duel.
    }
  },
};
